"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmphibianFarming = void 0;
var Tags_1 = require("../../Tags");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var Resources_1 = require("../../../Resources");
var Card_1 = require("../../Card");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRequirements_1 = require("../../CardRequirements");
var AmphibianFarming = (function (_super) {
    __extends(AmphibianFarming, _super);
    function AmphibianFarming() {
        return _super.call(this, {
            cost: 7,
            tags: [Tags_1.Tags.PLANT],
            name: CardName_1.CardName.AMPHIBIAN_FARMING,
            cardType: CardType_1.CardType.AUTOMATED,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oceans(2).max(); }),
            metadata: {
                cardNumber: 'L406',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(1); });
                }),
                description: 'Requires 2 or less ocean tiles. Increase your Plant production 1 step.',
            },
        }) || this;
    }
    AmphibianFarming.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        return undefined;
    };
    return AmphibianFarming;
}(Card_1.Card));
exports.AmphibianFarming = AmphibianFarming;
//# sourceMappingURL=AmphibianFarming.js.map